import { useCallback, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useUnmount } from "app/custom-hooks/useUnmount";

import { resetNameModalState, setJobName, setRenameModalOpen } from "../store/action-creators";
import { selectIsRenameModalOpen, selectJobName } from "../store/selectors";

type HookValue = {
    isNameModalOpen: boolean;
    jobName: string;
    onSetJobName: (name: string) => void;
    onNameModalTrigger: (isOpen: boolean) => void;
};

export const useJobNameModalState = (initialJobName?: string): HookValue => {
    const dispatch = useDispatch();

    const isNameModalOpen = useSelector(selectIsRenameModalOpen);
    const jobName = useSelector(selectJobName);

    const onNameModalTrigger = useCallback((isOpen: boolean): void => {
        dispatch(setRenameModalOpen(isOpen));
    }, []);

    const onSetJobName = useCallback((name: string): void => {
        dispatch(setJobName(name));
    }, []);

    useEffect(() => {
        if (!initialJobName) {
            return;
        }

        dispatch(setJobName(initialJobName));
    }, [initialJobName]);

    useUnmount(() => {
        dispatch(resetNameModalState());
    });

    return {
        isNameModalOpen,
        jobName,
        onNameModalTrigger,
        onSetJobName,
    };
};
